import { useState } from 'react'

export const useCopyToClipboard = () => {
    const [isCopied, setIsCopied] = useState(false)

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)

        setIsCopied(true)

        setTimeout(() => {
            setIsCopied(false)
        }, 3000)
    }

    return { isCopied, copyToClipboard }
}
